import { useEffect, useState } from "react";
import { AllCardsContainer, CardsColumnContainer, MainContainer, MainTitle } from "./brawler.styles";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Footer } from "../../components/footer/footer";
import { screenBreackpoints } from "../../theme";
import { useTranslation } from "react-i18next";
import { SeoHelmet } from "../../components/seo-helmet/seo-helmet";
import { useParams } from "react-router-dom";
import { getBrawlerStats } from "../../api/brawler-stats/brawler-stats";
import { BrawlerStats } from "../../api/brawler-stats/brawler-stats.types";
import { getBrawlerBuild } from "./brawler.functions";
import { BrawlerBuild, BuildType } from "./brawler.types";
import { PageContainer } from "../../components/base-components/base-componets";
import { BuildCard } from "./build-card/build-card";
import { BuildTop } from "./build-top/build-top";
import { RankedStats } from "./ranked-stats/ranked-stats";
import { ModeStatsCard } from "./mode-stats-card/mode-stats-card";
import { formatNameToTitleCase } from "../../shared/functions";
import { format } from "date-fns/format";


export const Brawler: React.FC = () => {
  const { id } = useParams();
  const [brawlerName] = useState<string>(id!);
  const [brawlerStats, setBrawlerStats] = useState<BrawlerStats>();
  const [build, setBuild] = useState<BrawlerBuild>();
  const isMobile = useMediaQuery(`(max-width:${screenBreackpoints.mobile})`);
  const { t } = useTranslation();

  useEffect(() => {
    const loadStats = async () => {
      try {
        const stats = await getBrawlerStats(brawlerName);
        const filteredRankedStats = stats.rankedStats.rankedStats.filter( //todo review this, Remove all maps statistics include it?
          battleStats => battleStats.eventId !== null
        );
        stats.rankedStats.rankedStats = filteredRankedStats;
        setBrawlerStats(stats);
        const build = getBrawlerBuild(stats);
        setBuild(build)
      } catch (error) {
        window.console.log(error)
      }
    };
    loadStats()
  }, [brawlerName]);

  const nameFormatted = brawlerStats?.brawler.name ? formatNameToTitleCase(brawlerStats?.brawler.name) : ""
  const title = t("PAGES.BRAWLER.SEO.TITLE", { brawler: nameFormatted })
  const description = t("PAGES.BRAWLER.SEO.DESCRIPTION", { brawler: nameFormatted })
  const keywords = t("PAGES.BRAWLER.SEO.KEYWORDS", { brawler: nameFormatted })

  return (
    <PageContainer isMobile={isMobile}>
      {brawlerStats ?
        <Box>
          <SeoHelmet title={title} description={description} keywords={keywords} />
          <MainTitle component="h1" isMobile={isMobile}>
            {title}
          </MainTitle>
          <Typography>
            {description +
              t("PAGES.BRAWLER.UPDATED_AT", {
                updatedAt: format(new Date(brawlerStats.brawler.statsUpdatedAt.seconds * 1000), 'dd/MM/yyyy')
              })}
          </Typography>
          <MainContainer>
            {brawlerStats && build &&
              <AllCardsContainer>
                <CardsColumnContainer>
                  <BuildTop
                    name={brawlerStats.brawler.name}
                    build={build}
                    pageTitle={title}
                  />
                  <BuildCard
                    brawlerName={brawlerStats.brawler.name}
                    buildItems={brawlerStats.brawler.starPowers}
                    buildType={BuildType.STAR_POWERS}
                  />
                  <BuildCard
                    brawlerName={brawlerStats.brawler.name}
                    buildItems={brawlerStats.brawler.gadgets}
                    buildType={BuildType.GADGETS}
                  />
                  <BuildCard
                    brawlerName={brawlerStats.brawler.name}
                    buildItems={brawlerStats.brawler.gears}
                    buildType={BuildType.GEARS}
                  />
                </CardsColumnContainer>
                <CardsColumnContainer>
                  <ModeStatsCard
                    modeStats={brawlerStats.modeStats.modeStats}
                  />
                  <RankedStats
                    rankedStats={brawlerStats.rankedStats.rankedStats}
                  />
                </CardsColumnContainer>
              </AllCardsContainer>
            }
          </MainContainer>
        </Box> :
        <Box>
          <MainTitle component="h1" isMobile={isMobile}>
            {t("PAGES.BRAWLER.FALLBACK")}
          </MainTitle>
        </Box>
      }
      <Footer />
    </PageContainer >
  );
}
